import { useState } from 'react';
import type { AccountTransferScheduleCancelRequest, AccountTransferScheduleCancelResponse } from 'vopay';
import { api } from '@/services/api.config';
import { useDataFetchIndicator } from '..';

export default function useCancelAccountTransferSchedule() {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [cancelling, setCancelling] = useState(false);

  async function cancelAccountTransferSchedule(
    params: AccountTransferScheduleCancelRequest,
  ): Promise<AccountTransferScheduleCancelResponse> {
    try {
      setCancelling(true);
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postAccountTransferScheduleCancel(params);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Cancel account transfer schedule failed:', error);
      throw error;
    } finally {
      setCancelling(false);
      setDataFetchingInfo(false);
    }
  }

  return { cancelling, cancelAccountTransferSchedule };
}
